import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import PageTitle from "../../components/pagetitle/PageTitle";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const coverageItems = [
  "TCUK Retail Auctions",
  "TCUK Cars Auctions",
  "TCUK Property Auctions",
  "TCUK Cars Sales",
  "TCUK Property Sales",
];

const operatingPoints = [
  "Provide structured and transparent auction listings",
  "Enable qualifying participants to bid or purchase",
  "Integrate TopCoin Loyalty within the platform as a utility mechanism",
  "Record platform activity securely using distributed ledger technology",
  "Apply defined participation standards and eligibility requirements",
  "Operate under clearly published terms and governance policies",
];

const loyaltyClarifications = [
  "Does not represent shares, securities, or regulated financial instruments",
  "Does not confer ownership rights in TopCoin UK Ltd or any associated entity",
  "Is not intended as an investment product",
  "Is not guaranteed to hold monetary value",
  "May be subject to eligibility criteria, usage restrictions, and platform conditions",
];

const developmentStatus = [
  "Listings will not be live",
  "No bids or offers may be submitted",
  "No TopCoin-based activity will be processed",
];

const interestReasons = [
  "Be notified when Auctions & Sales becomes available",
  "Enquire about participating as a retail partner, property introducer, motor agent, or customer",
  "Learn how TopCoin Loyalty will integrate into auctions and sales",
];

const Section = ({ title, children }) => (
  <section className="mb-4">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="mb-3">
            <h2 className="mb-3" style={{ fontSize: "28px", fontWeight: 700 }}>
              {title}
            </h2>
            <div className="bg-white border rounded-3 p-4 shadow-sm text-dark" style={{ lineHeight: 1.6 }}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const List = ({ items }) => (
  <ul className="mb-0" style={{ paddingLeft: "1.2rem" }}>
    {items.map((item) => (
      <li key={item} className="mb-2">
        {item}
      </li>
    ))}
  </ul>
);

const AuctionsSales = () => {
  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />
        <main className="page_content">
          <PageTitle pageTitle={"Auctions & Sales"} pagesub={"Home"} />

          <section className="py-1 mb-5">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="d-inline-flex align-items-center mb-3 px-3 py-2 rounded-pill border text-dark" style={{ background: "#f8f9fa", fontWeight: 600 }}>
                    <span style={{ fontSize: "20px", letterSpacing: "0.04em" }}>
                      Under Development
                    </span>
                  </div>
                  <div className="bg-white border rounded-3 p-4 shadow-sm text-dark" style={{ lineHeight: 1.7 }}>
                    <h1 className="mb-3 text-dark" style={{ fontSize: "30px", fontWeight: 700 }}>
                      Auctions & Sales Platform - Under Development
                    </h1>
                    <p className="mb-3">
                      TopCoin UK Ltd is currently developing its integrated Auctions & Sales Platform, which will operate across:
                    </p>
                    <List items={coverageItems} />
                    <p className="mt-3 mb-0">
                      This platform is being structured to operate within the TopCoin ecosystem and to integrate with our TopCoin Loyalty system. The Auctions & Sales services are not yet active and remain under structured development.
                    </p>
                    <p className="mt-3 mb-0">
                      No bidding, listings, purchases, or TopCoin-based activity can take place at this time.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <Section title="How the Platform Will Operate">
            <p className="mb-3">
              Upon launch, the platform is designed to:
            </p>
            <List items={operatingPoints} />
            <p className="mt-3 mb-0">
              Full participation terms, eligibility criteria, and platform conditions will be published prior to launch.
            </p>
          </Section>

          <Section title="TopCoin Loyalty - Important Clarification">
            <p className="mb-3">
              TopCoin Loyalty is designed exclusively for use within the TopCoin ecosystem. TopCoin:
            </p>
            <List items={loyaltyClarifications} />
            <p className="mt-3 mb-0">
              All participants will be required to review and formally accept the applicable Terms of Use before accessing Auctions & Sales services.
            </p>
          </Section>

          <Section title="Platform Development Status">
            <p className="mb-3">
              The Auctions & Sales infrastructure is currently undergoing technical build and compliance structuring. Until formal activation:
            </p>
            <List items={developmentStatus} />
            <p className="mt-3 mb-0">
              Further updates will be published in due course.
            </p>
          </Section>

          <Section title="Register Your Interest">
            <p className="mb-3">
              If you would like to:
            </p>
            <List items={interestReasons} />
            <p className="mt-3">
              Please contact our team via the Contact Us page.
            </p>
            <NavLink to="/contact" className="btn btn-primary" style={{ width: "fit-content" }}>
              Go to Contact Us
            </NavLink>
            <p className="mt-3 mb-0">
              We will respond as soon as reasonably practicable. We appreciate your patience while development is completed and look forward to launching a structured, transparent, and professionally governed marketplace platform.
            </p>
          </Section>
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </Fragment>
  );
};

export default AuctionsSales;
